/**
 * Auth Module - Vuex Store Module (TypeScript)
 *
 * Handles user authentication state and actions
 * - Login/logout flows
 * - Token management
 * - User session persistence
 * - Password reset
 * - Account deletion
 *
 * Uses AuthService for all API operations
 */

import { Module } from 'vuex';
import type { RootState } from '@/store/types';
import mutations, { initialAuthState, AuthState } from './mutations';
import getters from './getters';
import actions from './actions';

const module: Module<AuthState, RootState> = {
  namespaced: true,
  state: initialAuthState,
  mutations,
  getters,
  actions,
};

export default module;
export type { AuthState };
